module.exports = __webpack_public_path__ + "static/media/728x90_0013_ru.e8cc77db.jpg";